import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiArrowLeft, FiExternalLink } from 'react-icons/fi';
import { useThemeClasses } from '../../hooks/useThemeClasses';
import { ADMIN_ROUTE_LABELS } from './adminFormat';

export default function AdminTopBar() {
  const tc = useThemeClasses();
  const { pathname } = useLocation();
  const section = ADMIN_ROUTE_LABELS[pathname] || 'Administración';

  return (
    <div
      className={`sticky top-0 z-20 border-b backdrop-blur-md ${
        tc.modoOscuro ? 'bg-black/80 border-gray-800' : 'bg-[#f5f5f7]/90 border-gray-200'
      }`}
    >
      <div className="flex items-center justify-between gap-3 py-2.5 px-4 sm:px-6 min-w-0 max-w-full">
        <div className="flex items-center gap-2 min-w-0">
          <Link
            to="/inicio"
            className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium shrink-0 ${
              tc.modoOscuro ? 'text-gray-300 hover:bg-gray-900' : 'text-gray-600 hover:bg-white'
            }`}
          >
            <FiArrowLeft className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Producto</span>
          </Link>
          <span className={`hidden sm:inline ${tc.textMuted}`}>/</span>
          <span className={`text-xs truncate ${tc.textMuted}`}>Admin</span>
          <span className={`hidden md:inline ${tc.textMuted}`}>/</span>
          <span className={`hidden md:inline text-xs font-medium truncate ${tc.textPri}`}>{section}</span>
        </div>
        <Link
          to="/inicio"
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium ${tc.btnPrimary}`}
        >
          Ir a Contsuite
          <FiExternalLink className="w-3 h-3 opacity-80" />
        </Link>
      </div>
    </div>
  );
}
